// extracted by mini-css-extract-plugin
export default {"multiple_choice":"MultipleChoice_multiple_choice__Lg+Wd","unpressed":"MultipleChoice_unpressed__1ETN5","pressed":"MultipleChoice_pressed__MGVbu"};